import React from "react";
import { Link } from "react-router-dom";

import { Button, Loader } from "@components/atoms";
import { ProductTile } from "@components/molecules";

import { generateProductUrl, generateStoreProductUrl } from "../../../../core/utils";

import * as S from "./styles";
import { IProps } from "./types";

export const ProductList: React.FC<IProps> = ({
  products,
  canLoadMore = false,
  loading = false,
  testingContextId,
  isMerchantProduct,
  onLoadMore = () => null,
  isStorePage = false,
}: IProps) => {
  const generateUrl = location.pathname && location.pathname.startsWith("/store/") 
                    ? generateStoreProductUrl
                    : generateProductUrl;
  return (
    <>
      <S.List data-test="productList" data-test-id={testingContextId}>
        {products.map(product => (
          <Link style={{textDecoration: 'none'}}
            to={generateUrl(product.id, product.name)}
            key={product.id}
          >
            <ProductTile product={product} hideStoreTitle={isStorePage} isMerchantProduct={isMerchantProduct} />
          </Link>
        ))}
      </S.List>
      <S.Loader>
        {loading ? (
          <Loader />
        ) : (
          canLoadMore && (
            <Button
              testingContext="loadMoreProductsButton"
              color="secondary"
              onClick={onLoadMore}
            >
              <span>More +</span>
            </Button>
          )
        )}
      </S.Loader>
    </>
  );
};
